module.exports = __webpack_public_path__ + "img/no-image.92d1ab6e.svg";